import script from "./MeetingDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetingDetails.vue?vue&type=script&setup=true&lang=js"

import "./MeetingDetails.vue?vue&type=style&index=0&id=4003a83f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4003a83f"]])

export default __exports__